import { useCurrentConversation } from '../chat-store/useCurrentConversation';
import { useCurrentConversationId } from '../chat-store/useCurrentConversationId';

import { useConversationData } from './useConversationData';
import type { UseConversationProps } from './UseConversationProps';
import type { UseConversationResult } from './UseConversationResult';

export const useCurrentChatConversation = ({
	assistanceServiceParams,
}: Pick<UseConversationProps, 'assistanceServiceParams'> = {}): UseConversationResult => {
	const conversationId = useCurrentConversationId();
	const conversation = useCurrentConversation();

	return useConversationData({
		conversationId,
		conversation,
		assistanceServiceParams,
	});
};
